//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 08/10/2025
// Version       : 1
// Description   : Agregar relación entre tipos de vehículos y componentes
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../../services/apirest";
import {
  TextField,
  Stack,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

// ICONOS
import LinkIcon from "@mui/icons-material/Link";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AgregarRelacion(props) {
  const [componentes, setComponentes] = useState([]);
  const [componenteSeleccionado, setComponenteSeleccionado] = useState("");

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success"); // "success" | "error"

  //*************************************************************************************************************************************/

  const obtenerComponentes = () => {
    fetch(UrlApi + "/vehiculos_componentes/disponibles/" + props.row.id)
      .then((data) => data.json())
      .then((data) => setComponentes(data));
  };

  useEffect(() => {
    obtenerComponentes();
  }, []);

  //*************************************************************************************************************************************/

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  //*************************************************************************************************************************************/

  const guardarCrear = async (e) => {
    e.preventDefault();
    setDisBtn(true);

    try {
      const res = await fetch(UrlApi + "/relacion_tiposv_componentes", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_tipo_vehiculo: props.row.id,
          id_componente: componenteSeleccionado.id,
          estado: 1, // Relación activa por defecto
        }),
      });
      const data = await res.json();

      if (res.ok) {
        setSeverity("success");
        setColorMensaje("#D4EFDF");
        setMensaje("La relación se guardó exitosamente!");
      } else if (res.status === 409) {
        // Nombre duplicado
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.message || "La relación ya existe.");
        setDisBtn(false);
      } else {
        // Otro error
        setSeverity("error");
        setColorMensaje("#F1948A");
        setMensaje(data.error || "Error al guardar la relación.");
        setDisBtn(false);
      }
    } catch (err) {
      setSeverity("error");
      setColorMensaje("#F1948A");
      setMensaje("Error de red o servidor.");
      setDisBtn(false);
    } finally {
      // Muestro el snack en todos los casos
      setOpenSnack(true);
    }
  };

  //*************************************************************************************************************************************/

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);

    if (severity === "success") {
      // Refrescar datos y cerrar diálogo
      props.onRelacionGuardada();
      props.handleCloseAgregarRelacion();
      setDisBtn(false);
    }
    // Si fue error, no se cierra el diálogo y se reactiva el botón
  };

  return (
    <>
      <Box>
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 3,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              gap: 2,
            }}
          >
            {/* Título */}
            <Typography
              variant="h6"
              color="white"
              sx={{
                background:
                  "linear-gradient(135deg, #2B76A6 0%, #094d77ff 100%)",
                borderBottomRightRadius: "12px",
                padding: "12px 24px",
                fontWeight: 600,
              }}
            >
              Agregar Relación
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <form onSubmit={guardarCrear}>
            <Grid container spacing={2} alignItems="center" mt={1}>
              {/* Tipo de Tanque */}
              <Grid item xs={4}>
                <Typography
                  variant="subtitle1"
                  noWrap
                  title={props.row.nombre}
                  sx={{ fontWeight: 600, pl: { xs: 0, sm: 1 } }}
                >
                  {props.row.nombre}
                </Typography>
              </Grid>

              {/* Ícono */}
              <Grid item xs={2}>
                <LinkIcon fontSize="medium" color="primary" />
              </Grid>

              {/* Componente */}
              <Grid item xs={6}>
                <Box
                  display="flex"
                  justifyContent={{ xs: "flex-start", sm: "flex-end" }}
                >
                  <Autocomplete
                    disabled={!componentes}
                    required
                    disableClearable
                    size="small"
                    fullWidth
                    noOptionsText="Componente INEXISTENTE"
                    options={componentes}
                    autoHighlight
                    getOptionLabel={(c) => `${c.id} - ${c.nombre}`}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value?.id
                    }
                    value={componenteSeleccionado || null}
                    onChange={(e, value) => setComponenteSeleccionado(value)}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.id}>
                        {option.id} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        label="Componente"
                        placeholder="Tipee para buscar..."
                        inputProps={{ ...params.inputProps }}
                      />
                    )}
                  />
                </Box>
              </Grid>

              {/* BOTONES EN LÍNEA */}
              <Grid item xs={12} mt={3}>
                <Box display="flex" justifyContent="space-between">
                  <Button
                    variant="contained"
                    color="error"
                    onClick={props.handleCloseAgregarRelacion}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={disBtn}
                    sx={{
                      borderRadius: "12px",
                      textTransform: "none",
                      fontWeight: 600,
                    }}
                  >
                    Guardar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={severity}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default AgregarRelacion;
